import Header from './Components/Layout/Header';
import Footer from './Components/Layout/Footer';
import Hero from './Components/Sections/Hero';
import Services from './Components/Sections/Services';
import SuccessCases from './Components/Sections/SuccessCases';
import Benefits from './Components/Sections/Benefits';
import Brands from './Components/Sections/Brands';
import Cta from './Components/Sections/Cta';

function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <div className="section-divider" />
        <Services />
        <div className="section-divider" />
        <SuccessCases />
        <div className="section-divider" />
        <Benefits />
        <div className="section-divider" />
        <Brands />
        <div className="section-divider" />
        <Cta />
      </main>
      <Footer />
    </>
  );
}

export default App;